import Modal from '../Shared/Modal';
import { getBookingPageTheme, getThemedBg } from '../../utility/themeVars';
import { hasAnyPolicy } from './policyMeta';
import PolicySections from './PolicySections';

/**
 * Full-text "Things to know" sheet shared by every policy trigger
 * (PoliciesLink, PoliciesAgreementNote).
 *
 * Purely presentational — the parent owns the open/onClose state.
 * Returns null when the provider has no policies set.
 *
 * Headless UI's Dialog portals to document.body, escaping
 * PublicBookingLayout's --theme-* scope, so the theme vars are
 * re-injected onto the DialogPanel via themeStyle (same pattern
 * as ProviderBioModal).
 */
const PoliciesDrawer = ({ open, onClose, bookingPage }) => {
  if (!hasAnyPolicy(bookingPage)) {
    return null;
  }

  const { themeMode, primaryColor } = getBookingPageTheme(bookingPage);
  const themedBg = getThemedBg(themeMode, primaryColor);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Things to know"
      size="md"
      themedBg={themedBg}
      themeStyle={themedBg.style}
    >
      <PolicySections bookingPage={bookingPage} />
    </Modal>
  );
};

export default PoliciesDrawer;
